// extracted by mini-css-extract-plugin
module.exports = {"root":"MantineAlert_root__gAAMj","icon":"MantineAlert_icon__MoMG_","message":"MantineAlert_message__mfpBJ"};